import apiFetch from '../apiFetch'

export default function (token, campaignDetailId) {
  const queryParamsArray = [
    `campaignDetailId=${campaignDetailId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `/CampaignDetails/CampaignDetailsCountry${queryParams}`, method: 'GET', body: null, token: token })
}
